import createHistory from 'history/createBrowserHistory';
import {routerMiddleware, routerReducer} from 'react-router-redux';
import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import {createLogger} from 'redux-logger';
import {autoRehydrate} from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import AppConfig from '../config/AppConfig';
import ReduxPersist from '../config/ReduxPersist';
import RehydrationServices from '../helpers/RehydrationServices';
import reducers from '../redux/reducers';
import rootSaga from '../redux/sagas';

let store: any;
let history: any;
if (!global.__TEST__) {

    /* ------------- Redux Configuration ------------- */

    const middleware: any[] = [];
    const enhancers: any[] = [];

    history = createHistory();
    const sagaMiddleware = createSagaMiddleware();
    const routeMiddleware = routerMiddleware(history);

    if (AppConfig.isDevelopment) {
        const logger = createLogger({
            predicate: (getState, action) => action.type !== 'COLLAPSE_OPEN_DRAWER'
        });
        middleware.push(logger);
    }
    middleware.push(thunk);
    middleware.push(sagaMiddleware);
    middleware.push(routeMiddleware);


    /* ------------- Assemble Middleware ------------- */

    enhancers.push(applyMiddleware(...middleware));

    /* ------------- AutoRehydrate Enhancer ------------- */

// add the autoRehydrate enhancer
    if (ReduxPersist.active) {
        enhancers.push(autoRehydrate());
    }

    store = createStore(combineReducers({
        ...reducers,
        router: routerReducer
    }), compose(...enhancers));

    if (ReduxPersist.active) {
        RehydrationServices.updateReducers(store);
    }

    sagaMiddleware.run(rootSaga);

}

export {store, history};



// WEBPACK FOOTER //
// ./src/redux/store.ts